import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

type Props = {
  children: string;
};

export const DocumentTitle = ({ children }: Props): JSX.Element => {
  const { t } = useTranslation();
  const defaultTitle = t('page.defaultTitle');

  return (
    <Helmet>
      <title>{children || defaultTitle} | Expressable</title>
    </Helmet>
  );
};
